import styled from '@emotion/styled';

const ToolbarHeader = styled('div')`
  font-size: 12px;
  text-transform: uppercase;
  font-weight: bold;
  color: ${p => p.theme.gray600};
`;

export default ToolbarHeader;
